import React from 'react';
import { TextInputWUT } from '../../inputs/text-input-wut/text-input-wut';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { Widget } from '../widget/widget';
export const TextInputFieldWUT = ({ id, target, label, hideLabel = false, placeholder, required = false, description, value = '', onChange, onBlur, onFocus, error, hasError = false, errorMessage, type = 'text', disabled = false, readOnly, prefix, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement, showPasswordTooltipText, hidePasswordTooltipText, widgetHtml, widgetEnabled, media, mediaSettings })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement,
                media: media,
                mediaSettings: mediaSettings
            }),
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: onChange,
                value: value
            }) : /*#__PURE__*/ React.createElement(TextInputWUT, {
                label: label,
                placeholder: placeholder,
                required: required,
                value: value,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                type: type,
                disabled: disabled,
                readOnly: readOnly,
                prefix: prefix,
                inputId: inputId,
                ariaDescribedBy: ariaDescribedBy,
                hasError: hasError,
                fieldId: id,
                showPasswordTooltipText: showPasswordTooltipText,
                hidePasswordTooltipText: hidePasswordTooltipText
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=text-input-field-wut.js.map